<template>
  <div>
    <Row :gutter="8">
      <Col span="4">
        <Input v-model="goodsName" type="text" placeholder="物品名称" clearable @on-clear="searchChange" />
      </Col>
      <Col span="8">
        <Button type="primary" icon="ios-search" @click="search" style="margin-right:5px">查询</Button>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Table border ref="table" size="small" :columns="columns" :data="tableData" :height="tableHeight"></Table>
      </Col>
    </Row>
    <Row>
      <Col span="24" style="text-align:center">
        <Page :total="total" :page-size="pageSize" :current="pageNumber" show-elevator show-sizer show-total
          @on-change="pageChange" @on-page-size-change="pageSizeChange" />
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "integralExchangeRecord",
  data() {
    return {
      goodsName: "",
      columns: [
        { title: "序号", width: 80, align: "center", render: (h, p) => h("span", p.index + 1) },
        { title: "物品名称", key: "goodsName", minWidth: 130, align: "center", tooltip: true },
        { title: "兑换人", key: "name", minWidth: 100, align: "center" },
        { title: "身份证号码", key: "idCard", minWidth: 180, align: "center" },
        { title: "兑换单价", key: "integralBranch", minWidth: 80, align: "center" },
        { title: "兑换数量", key: "exchangeCount", minWidth: 80, align: "center" },
        { title: "消耗积分", key: "totalBranch", minWidth: 80, align: "center" },
        { title: "兑换时间", key: "exchangeTime", minWidth: 160, align: "center", tooltip: true },
        {
          title: "审核状态", key: "status", minWidth: 100, align: "center",
          render: (h, p) => h("span", p.row.status == 10 ? "已审核" : p.row.status == 15 ? "已拒绝" : "待审核"),
        },
        {
          title: "操作", minWidth: 160, align: "center",
          render: (h, p) => {
            if (p.row.status == 10 || p.row.status == 15) return h("span", "--");
            return h("div", [
              h("Button", { style: { margin: "0 5px" }, props: { type: "primary", size: "small" }, on: { click: () => this.approve(p.row.id) } }, "审核"),
              h("Button", { style: { margin: "0 5px 0 0" }, props: { type: "error", size: "small" }, on: { click: () => this.reject(p.row.id) } }, "拒绝"),
            ]);
          },
        },
      ],
      tableData: [], tableHeight: 500, total: 0, pageNumber: 1, pageSize: 10,
    };
  },
  created() { this.getData(); },
  mounted() { this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 220; },
  methods: {
    getData() {
      let msg = this.$Message.loading({ content: "正在获取数据", duration: 0 });
      this.$http.get("/api/tIntegralExchangeRecord/page", { params: { goodsName: this.goodsName, currentPage: this.pageNumber, pageSize: this.pageSize } }).then(r => { msg(); if (r.data.code == 200) { this.tableData = r.data.data.list; this.total = r.data.data.total; } }).catch(() => msg());
    },
    search() { this.pageNumber = 1; this.getData(); },
    pageChange(p) { this.pageNumber = p; this.getData(); },
    pageSizeChange(s) { this.pageSize = s; this.pageNumber = 1; this.getData(); },
    approve(id) { this.$Modal.confirm({ title: "提示", content: "确认审核通过？", onOk: () => { this.$http.get("/api/tIntegralExchangeRecord/approve", { params: { id } }).then(r => { if (r.data.code == 200) { this.$Message.success("审核成功"); this.getData(); } }); } }); },
    reject(id) { this.$Modal.confirm({ title: "提示", content: "确认拒绝？", onOk: () => { this.$http.get("/api/tIntegralExchangeRecord/reject", { params: { id } }).then(r => { if (r.data.code == 200) { this.$Message.success("已拒绝"); this.getData(); } }); } }); },
    searchChange() { this.getData(); },
  },
};
</script>
<style scoped>.ivu-row { margin-bottom: 10px; }</style>
